export default {
	"保存": 'Save',
	"内部测试": 'Internal testing',
	"外部测试": 'External testing',
	'导出': 'Export',
	'导入': 'Import',
	'新建一页': 'Create a new page',
	'新建一题': 'Create a new question',
	"全部展开": 'Show all',
	"全部收起": 'Fold all',
	"编辑": 'Edit',
	"查看帮助": 'View help?',
	'确定': 'Confirm',
	'关闭': 'Close',
	'取消': 'Cancel',
	"修改": 'Modify',
	"提交": 'Submit',
	"下一页": 'Next page',
	"关闭": 'Close',
	"点击上传": 'Click to upload',
	"新增": 'Add',
	"新增列问题": 'Add new column',
	"新增行问题": 'Add new row',
	"新增选项": 'Add new options',
	"题库": 'Question bank',
	"选择分类": 'Select classification',
	"新增问题": 'Add new question',
	"是": 'Yes',
	"否": 'No',
	"长按开始语音作答": 'Long press to start voice response',
	"下一题": 'Next question',
  "清除":'Eliminate',
  "点击签名":'Click to sign',
  "新增分类":'Add Category',
  "下载模板":'Download Template'
}